import React from 'react';

const ProgressBar = ({ value, bgColor = "bg-gray-300", fgColor = "bg-green-600" }) => {
    return (
        <div className={`${bgColor} w-full h-1.5 rounded`} aria-hidden="true">
            <div 
                className={`${fgColor} rounded h-1.5`} 
                style={{ width: `${value}%` }}
            />
        </div>
    );
};

export default ProgressBar; 